module.exports = __webpack_public_path__ + "img/financialtimes.5f6505fa.png";